import { motion } from 'framer-motion'
import { Logo, Icon } from '../Brand'
import { initialsFromName } from '../../lib/user'
import { agentMeta } from './agentMeta'

// Left rail: brand, signed-in user, the agent roster, and a log-out control.
export default function AgentRail({ agents = [], activeName = null, onSelect = () => {}, user = null, onLogout = () => {} }) {
  return (
    <motion.aside
      className="ws-rail"
      initial={{ x: -20, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="ws-rail-logo"><Logo height={24} /></div>

      <div className="ws-rail-user">
        <div className="avatar" style={{ background: 'var(--coral-400)' }}>
          {initialsFromName(user?.name)}
        </div>
        <div className="who">
          <b>{user?.name || 'Guest'}</b>
          <span>{user?.user_id ? `@${user.user_id}` : 'signed in'}</span>
        </div>
      </div>

      <div className="ws-rail-label">Agents</div>
      <div className="ws-agents">
        {agents.map((a) => {
          const meta = agentMeta(a.name)
          const active = a.name === activeName
          return (
            <motion.button
              key={a.name}
              type="button"
              className={`ws-agent ${active ? 'active' : ''}`}
              onClick={() => onSelect(a.name)}
              whileHover={{ x: active ? 0 : 3 }}
              transition={{ type: 'spring', stiffness: 400, damping: 28 }}
            >
              <span className="ws-agent-ic"><Icon name={meta.icon} /></span>
              <span className="ws-agent-t">
                <b>{meta.label}</b>
                <span>{meta.blurb || a.description || ''}</span>
              </span>
            </motion.button>
          )
        })}
      </div>

      <div className="ws-rail-spacer" />

      <button type="button" className="ws-logout" onClick={onLogout}>
        <Icon name="logout" />Log out
      </button>
    </motion.aside>
  )
}
